import { useState, useCallback } from 'react';
import { Transak } from '@transak/transak-sdk';

export const useTransakWidget = (config = {}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openTransakWidget = useCallback(() => {
    // Default configuration
    const defaultConfig = {
      apiKey: process.env.REACT_APP_TRANSAK_API_KEY || '',
      environment: Transak.ENVIRONMENTS.STAGING, // Use PRODUCTION for live
      defaultCryptoCurrency: 'ETH',
      networks: 'ethereum',
      ...config
    };

    try {
      // Create and initialize Transak instance
      const transakInstance = new Transak(defaultConfig);

      // Event listener for widget close
      const handleWidgetClose = () => {
        console.log('Transak widget closed');
        setIsOpen(false);
        transakInstance.close();
      };

      // Event listener for order creation
      const handleOrderCreated = (orderData) => {
        console.log('Transak order created:', orderData);
      };

      // Event listener for successful order
      const handleOrderSuccessful = (orderData) => {
        console.log('Transak order successful:', orderData);
        transakInstance.close();
        setIsOpen(false);
      };

      // Add event listeners
      Transak.on(Transak.EVENTS.TRANSAK_WIDGET_CLOSE, handleWidgetClose);
      Transak.on(Transak.EVENTS.TRANSAK_ORDER_CREATED, handleOrderCreated);
      Transak.on(Transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, handleOrderSuccessful);

      // Open the widget
      transakInstance.init();
      setIsOpen(true);

    } catch (error) {
      console.error('Error opening Transak widget:', error);
      setIsOpen(false);
    }
  }, [config]);

  return {
    openTransakWidget,
    isOpen
  };
};
